<script type="text/ecmascript-6">
    import DesignerQuestionGlassDesign from "../DesignerQuestionGlassDesign.vue";

    export default {
        mixins: [
            DesignerQuestionGlassDesign
        ],
        computed: {
            panel_required(){
                return this.filtered_option_list.length > 1;
            },
        },
    }
</script>
